module.exports = __webpack_public_path__ + "img/premiation-viagem-chile.89de05c8.jpeg";